/* eslint-disable camelcase */
/* eslint-disable no-underscore-dangle */
// Here's another piece of our router...
// @TODO consolidate all of this routing crap

// Monitor history and adapt as required (deals with new landings as well)
window.onpopstate = function onpopstate(event: TSFixMe) {
  $('body,html').scrollTop(0);
  if (event.state === null && !window._history_pushed) {
    window.merchantos.debug(`popState with null event: ${window.location.href}`);
    return; // don't do anything on initial page load in browsers that popstate on load (Chrome + Safari)
  }
  window.saveOnChanges();

  if (window._ignore_popstate) {
    /*
     * See view.js note about setting _ignore_popstate
     *
     * When ignore_popstate is set it means we do not want to actually
     * route, instead we just want to replace the current state with
     * updateHistory(...,..,true,...).
     */
    window.updateHistory(
      window._ignore_popstate[0],
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      window._ignore_popstate[1].title,
      true,
      window._ignore_popstate[1]
    );
    // @ts-expect-error ts-migrate(2322) FIXME: Type 'undefined' is not assignable to type '[strin... Remove this comment to see the full error message
    window._ignore_popstate = undefined;
    return;
  }
  let viewContext;
  if (event.state && event.state.rec_num) {
    viewContext = event.state;
  }

  window.popParent();

  window.merchantos.router.route(window.location.href, viewContext);
};

window.updateHistory = function updateHistory(url, title, edit, viewContext) {
  window._history_pushed = true;
  // make sure browser supports history and pushstate
  if (window.history && history.pushState) {
    let shopName = '';
    // handle null being returned from getShop gracefully:
    if (window.merchantos.session.getShop()) {
      // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
      shopName = window.merchantos.session.getShop().name;
    }

    if (!title) {
      // eslint-disable-next-line no-param-reassign
      title = window.config.app_ui_name;
    }

    const index = title.indexOf(':');
    let item;
    if (index !== -1) {
      item = title.substring(index + 1).replace(/<\/?var>/g, '');
      // eslint-disable-next-line no-param-reassign
      title = title.substring(0, index + 1);
    }

    if (window.lsCloud.Modules.hasModule('i18n.localizejs') && typeof Localize !== 'undefined') {
      let paramString = '';
      const params = { shop_name: shopName, app_name: window.config.app_ui_name };
      if (typeof item !== 'undefined') {
        paramString = ' %{item}';
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'item' does not exist on type '{ shop_nam... Remove this comment to see the full error message
        params.item = item;
      }

      paramString += ' - %{shop_name} (%{app_name})';
      // eslint-disable-next-line no-param-reassign
      title += paramString;
      Localize.translate(title, params, translation =>
        $('title')
          .first()
          .html(translation)
      );
    } else {
      // eslint-disable-next-line no-param-reassign
      title += ` - ${shopName} (${window.config.app_ui_name})`;
      $('title')
        .first()
        .html(title);
    }

    if (edit) {
      history.replaceState(viewContext, title, url);
    } else {
      history.pushState(viewContext, title, url);
      window.PageRouter.unmount();

      // We only want to hide existing notifiers if we're actually
      // navigating
      window.hideAllNotifiers();
    }

    window.lsCloud.analytics.record();
  }
};

class Router implements MerchantosRouter {
  route = (url: TSFixMe, viewContext: TSFixMe) => {
    window.hideAllNotifiers();

    // Parse the URL
    const searchParams = window.merchantos.utils.getQueryParams(url);
    let form_name = searchParams.form_name;

    /**
     * Sets the form_nme to 'clientURL' if the URL requested is one defined by Backbone
     * This is done to handle Browser History properly.
     */
    window.merchantos.register.ensureAppIsDefined();
    if (window.App.isClientUrl(url)) {
      form_name = 'clientURL';
    }

    if (!form_name) {
      if (searchParams.file === 'register.php' || searchParams.file === '') {
        window.setCrumbs([window.crumbItem(window.config.app_ui_name, 'register')]);
        window.merchantos.display.showRegister();
        window.merchantos.register.changeView('sale');
      }
      return;
    }

    // eslint-disable-next-line default-case
    switch (form_name) {
      case 'listing':
        if (!searchParams.name) {
          break;
        }
        const comp_name = searchParams.name;
        const paramKeys = Object.keys(searchParams);
        const initSearchParams = paramKeys.reduce((params, key) => {
          const value = searchParams[key];
          if (key === 'form_name' || key === 'name') return params;
          // @ts-expect-error ts-migrate(2322) FIXME: Type 'string' is not assignable to type 'never'.
          params.push([key, value]);
          return params;
        }, []);

        window.navigateToContent('listing', comp_name, initSearchParams);
        break;
      case 'view':
        if (!searchParams.name) {
          break;
        }
        window.navigateToContent(
          'view',
          searchParams.name,
          searchParams.id,
          searchParams.tab,
          viewContext
        );
        break;
      case 'ui_tab':
        window.merchantos.tabs.show(searchParams.tab);
        break;
      case 'change_view':
        window.setCrumbs([window.crumbItem(window.config.app_ui_name, form_name)]);
        window.merchantos.display.showRegister();
        window.merchantos.register.changeView(searchParams.view);
        break;
      case 'do_payments':
        window.setCrumbs([window.crumbItem(window.config.app_ui_name, form_name)]);
        window.merchantos.display.showRegister();
        window.merchantos.register.donePay();
        break;
      case 'clientURL': // If it's clientURL, do nothing, let the webpack'ed client code handle it.
        break;
    }
  };
}

window.merchantos.router = new Router();
